import FillHeartIcon from "@/components/icons/FillHeartIcon";
import HeartIcon from "@/components/icons/HeartIcon";
import { useRouter } from "next/router";

const AddtoWishlist = ({ onClick, isWishlisted, fromAlbum }) => {
  const { locale } = useRouter();
  return (
    <div
      onClick={onClick}
      aria-label="Add To Wishlist"
      className={`absolute ${
        !fromAlbum ? (locale === "en" ? "right-0" : "left-0") : "right-3"
      }
      } z-30 cursor-pointer top-3 text-secondary-800`}
    >
      {isWishlisted ? (
        <FillHeartIcon
          className={`${fromAlbum ? "size-5 sm:size-7" : "size-4 sm:size-6"}`}
        />
      ) : (
        <HeartIcon
          className={`${fromAlbum ? "size-5 sm:size-7" : "size-4 sm:size-6"}`}
        />
      )}
    </div>
  );
};

export default AddtoWishlist;
